import { SVGProps } from "react"

const ValidPromoCodeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.41592 2.26948C7.26101 1.32548 8.73899 1.32548 9.58408 2.26948C10.0148 2.75059 10.6408 3.00989 11.2855 2.97424C12.5506 2.9043 13.5957 3.94939 13.5258 5.21447C13.4901 5.85922 13.7494 6.48522 14.2305 6.91592C15.1745 7.76101 15.1745 9.23899 14.2305 10.0841C13.7494 10.5148 13.4901 11.1408 13.5258 11.7855C13.5957 13.0506 12.5506 14.0957 11.2855 14.0258C10.6408 13.9901 10.0148 14.2494 9.58408 14.7305C8.73899 15.6745 7.26101 15.6745 6.41592 14.7305C5.98522 14.2494 5.35922 13.9901 4.71447 14.0258C3.44939 14.0957 2.4043 13.0506 2.47424 11.7855C2.50989 11.1408 2.25059 10.5148 1.76948 10.0841C0.825477 9.23899 0.825477 7.76101 1.76948 6.91592C2.25059 6.48522 2.50989 5.85922 2.47424 5.21447C2.4043 3.94939 3.44939 2.9043 4.71447 2.97424C5.35922 3.00989 5.98522 2.75059 6.41592 2.26948Z"
      fill="#0A9A22"
    />
    <path d="M4.55469 8.50005L6.77691 10.7223L11.2214 6.27783" fill="#0A9A22" />
    <path
      d="M4.55469 8.50005L6.77691 10.7223L11.2214 6.27783"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ValidPromoCodeIcon
